import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { BaseButton } from './BaseButton';

interface TextButtonProps {
    onClick?: () => void;
    disabled?: boolean;
    type?: 'button' | 'submit';
    color?: string;
    size?: number;
    children: React.ReactNode;
}

export function TextButton({ onClick, disabled, type = 'button', color, size, children }: TextButtonProps) {
    return (
        <StyledTextButton type={type} onClick={onClick} disabled={disabled} color={color} size={size}>
            {children}
        </StyledTextButton>
    );
}

const StyledTextButton = styled(BaseButton)<{ color?: string; size?: number }>(({ color, size }) => ({
    color: color || Colors.primary,
    display: 'flex',
    alignItems: 'center',
    gap: 3,
    fontSize: size || 14,
    fontWeight: 600,
    textDecoration: 'underline',
    '&:focus, &:focus-visible': {
        color: Colors.textSecondary,
    },
}));
